(exports.OP_ID = "6ad628cfb77b1bca29c633ba"),
  (exports.FORM_ID = "692e96eec20f614d5eea04aa"),
  (exports.SERVER_URL = "https://api.accompagnement-hva.fr"),
  (exports.UPDATE = "6878fc947e06ac29cf5672e2"),
  (exports.ITEMS = "692e96eec20f614d5eea04aa"),
  (exports.BD_NAME = "jeu-dev");
